import { createReducer } from '@reduxjs/toolkit';
import { updateAgreementPolicy } from './actions';
import { agreementInitialState } from './state';

export const agreementReducer = createReducer(agreementInitialState, (builder) => {
  builder.addCase(updateAgreementPolicy, (state, { payload }) => {
    state.policy = payload;
  });
});
